export default __webpack_public_path__ + "static/media/info-sign.e3747acc.svg";